import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";
import styles from "../Styles";
import DateUtils from "src/services/utils/DateUtils";
import CompanyInformation from "./CompanyInformation";
import ContactRegistryInformation from "./ContactRegistryInformation";
import ManagementTable from "./ManagementTable";
import FinancialSummary from "./FinancialSummary";
import OwnershipBreakdown from "./OwnershipBreakdown";
import LegalDocuments from "./LegalDocuments";
import { INTERNATIONAL_MOMENT_DATE_FORMAT } from "src/components/constants";

const Sections = (props) => {
  const { noteBackgroundColor, detailsQuery } = props;
  const { company, financial_summary, management_team } = detailsQuery || {};
  const dateUtils = new DateUtils();
  const convertApiDate = (dateStr) => {
    return dateUtils.convertDateToDate(dateStr, INTERNATIONAL_MOMENT_DATE_FORMAT);
  };

  const fsAttrs = financial_summary?.rawData?.attributes || {};
  const currencyLocal =
    fsAttrs?.revenue?.unit || financial_summary?.currency || "EUR";

  const money = (value, unit = currencyLocal) => {
    if (value === null || value === undefined || value === "") return "-";
    return Intl.NumberFormat("en-US", {
      style: "currency",
      currency: unit,
      maximumFractionDigits: 0,
    }).format(Number(value));
  };

  const percent = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return `${Number(value).toFixed(2)}%`;
  };

  const safeJson = (str) => {
    try {
      return str ? JSON.parse(str) : null;
    } catch (e) {
      return null;
    }
  };

  const pct = (n) =>
    typeof n === "number" && !Number.isNaN(n) ? `${n.toFixed(2)}%` : "-";

  styles.sectionSeparator.backgroundColor = noteBackgroundColor;

  return (
    <View>
      <CompanyInformation company={company} convertApiDate={convertApiDate} />

      <ContactRegistryInformation company={company} />

      <ManagementTable management_team={management_team} />

      <FinancialSummary
        financial_summary={financial_summary}
        money={money}
        fsAttrs={fsAttrs}
        percent={percent}
        currencyLocal={currencyLocal}
      />

      <OwnershipBreakdown safeJson={safeJson} pct={pct} company={company} />

      <LegalDocuments company={company} />
    </View>
  );
};

export default withNamespaces()(Sections);
